import { render, staticRenderFns } from "./items-grid-media.vue?vue&type=template&id=5f13e632&scoped=true&"
import script from "./items-grid-media.vue?vue&type=script&lang=js&"
export * from "./items-grid-media.vue?vue&type=script&lang=js&"
import style0 from "./items-grid-media.vue?vue&type=style&index=0&id=5f13e632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f13e632",
  null
  
)

export default component.exports